import { ReactNode } from "react";
import { AmplitudeAnalyticsProvider } from "./AmplitudeContext";
import { LocalAnalyticsProvider } from "./LocalAnalyticsProvider";

export const AnalyticsProvider = ({ children }: { children: ReactNode }) => {
  const isDev = import.meta.env.VITE_NODE_ENV === "development";

  if (isDev) {
    return <LocalAnalyticsProvider>{children}</LocalAnalyticsProvider>;
  }

  return (
    <AmplitudeAnalyticsProvider
      apiKey={import.meta.env.VITE_APP_AMPLITUDE_API_KEY}
    >
      {children}
    </AmplitudeAnalyticsProvider>
  );
};
